import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { FullOffer } from '../models/class/offer/offer';
import { AuthService } from '../services/auth/auth.service';
import { DataService } from '../services/data/data.service';
import { ImgOfferDefaultService } from '../services/img-offer-default/img-offer-default.service';

@Injectable({
  providedIn: 'root'
})
export class RoleOfUserGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private dataService: DataService,
    private imgOfferDefault: ImgOfferDefaultService,
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const user = this.authService.getDecodedToken();

    switch (user.role) {
      case 'admin':
        // this.dataService.showTableOfferAdmin.next(true);
        this.dataService.titleAdminOffer.next('Liste des offres');
        break;
      case 'club':
        this.dataService.showTableOfferAdmin.next(false);

        break;

      default:
        break;
    }
    return true;
  }

}
